import ChatMessage from "@/components/ChatMessage";
import DesignGallery from "@/components/DesignGallery";
import PaymentPanel from "@/components/PaymentPanel";
import { proxyImg } from "@/utils/imageProxy";

export default function ChatMessageList({
  chatItems,
  selectedDesign,
  onDesignSelect,
  onPaymentVerified,
  onBrowseAll,
}) {
  return chatItems.map((item, i) => {
    if (item.type === "gallery") {
      return (
        <div key={item.id} data-message-id={item.id}>
          <DesignGallery
            collectionName={item.collectionName}
            designs={item.designs}
            onDesignSelect={onDesignSelect}
            selectedDesignId={selectedDesign?.id}
          />
        </div>
      );
    }
    if (item.type === "payment") {
      return (
        <div key={item.id} data-message-id={item.id} className="mt-4 animate-fade-in-up" data-testid="payment-panel-wrapper">
          <PaymentPanel
            bookingId={item.bookingId}
            totalAmount={item.totalAmount}
            customerName={item.customerName}
            customerPhone={item.customerPhone}
            customerEmail={item.customerEmail}
            onPaymentVerified={onPaymentVerified}
          />
        </div>
      );
    }
    if (item.selectedDesignCard) {
      return (
        <div key={item.id} data-message-id={item.id}>
          <ChatMessage message={item} index={i} onBrowseAll={item.role === "assistant" ? onBrowseAll : undefined} />
          <div className="ml-11 mt-2 flex items-center gap-3 p-3 bg-gray-50 rounded-xl border border-gray-200" data-testid="selected-design-preview">
            <img
              src={proxyImg(item.selectedDesignCard.image)}
              alt={item.selectedDesignCard.name}
              className="w-16 h-16 rounded-lg object-cover border border-gray-200"
              data-testid="selected-design-preview-img"
            />
            <div>
              <p className="text-xs font-semibold text-gray-900">{item.selectedDesignCard.name}</p>
              <p className="text-[11px] text-gray-500 line-clamp-2 mt-0.5">{item.selectedDesignCard.description}</p>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div key={item.id} data-message-id={item.id}>
        <ChatMessage message={item} index={i} onBrowseAll={item.role === "assistant" ? onBrowseAll : undefined} />
      </div>
    );
  });
}
